import { BtnPrimary } from '@components/buttons';
import { generateInitialContent } from './initial-content';
import { useCurrentTenant, useCurrentUser } from 'client/lib/auth';
import { type SalespageContent } from 'server/types';
import { rpx } from 'client/lib/rpx-client';
import { useState } from 'preact/hooks';

type EmptyPageProps = {
  onContentGenerated: (content: SalespageContent) => void;
};

export function EmptyPage({ onContentGenerated }: EmptyPageProps) {
  const user = useCurrentUser();
  const tenant = useCurrentTenant();
  const [isLoading, setIsLoading] = useState(false);

  async function generatePage() {
    setIsLoading(true);
    try {
      const initialContent = await rpx.ruzcal.getInitialHostPageContent();
      if (initialContent) {
        onContentGenerated(initialContent);
      } else {
        const newContent = generateInitialContent({
          userId: user!.id,
          domain: tenant.domain,
        });
        onContentGenerated(newContent);
      }
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div class="p-8">
      <div class="max-w-2xl mx-auto bg-gray-50 rounded-lg p-8 text-center">
        <h3 class="text-lg font-medium mb-4">Create Your Calendar Landing Page</h3>
        <p class="text-gray-600 mb-6">
          Build a beautiful landing page for your calendar bookings in seconds
        </p>
        <BtnPrimary class="rounded-full" onClick={generatePage} isLoading={isLoading}>
          Generate My Page
        </BtnPrimary>
        <div class="mt-6 text-sm text-gray-500">
          This will create a professional landing page with hero section, services, testimonials,
          and call-to-action
        </div>
      </div>
    </div>
  );
}
